import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

interface ICardFieldProps<T extends string> {
  label: string;
  placeholder: string;
  options: T[];
  value: T[];
  getOptionLabel?: (option: T) => string;
  onChange: (value: T[]) => void;
}

export const CardField = <T extends string>({
  label,
  placeholder,
  options,
  value,
  getOptionLabel,
  onChange,
}: ICardFieldProps<T>) => (
  <Autocomplete
    multiple
    options={options}
    value={value}
    getOptionLabel={getOptionLabel}
    onChange={(_, next) => onChange(next)}
    sx={{ '& .MuiInputBase-root': { minHeight: '3.5rem' } }}
    renderInput={(params) => (
      <TextField
        {...params}
        label={label}
        placeholder={value.length ? undefined : placeholder}
        InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
      />
    )}
  />
);
